import toDate from '../to-date';

export const isWithinInterval = (
  date: Date | number,
  interval: { start: Date | number; end: Date | number }
): boolean => {
  const { start, end } = interval;

  const formattedTime = toDate(date).getTime();
  const formattedStartTime = toDate(start).getTime();
  const formattedEndTime = toDate(end).getTime();

  return formattedTime >= formattedStartTime && formattedTime <= formattedEndTime;
};

export default isWithinInterval;
